export default "__VITE_ASSET__CRlSFQ5M__"